export function hex2rgba(hex: string, alpha?: string | number) {
	let c: any;
	const a = alpha ? parseFloat(String(alpha).replace('%', '')) / 100 : 1;
	if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
		c = hex.substring(1).split('');
		if (c.length === 3) {
			c = [c[0], c[0], c[1], c[1], c[2], c[2]];
		}
		c = '0x' + c.join('');
		return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255, a].join(',') + ')';
	}
	throw new Error('Bad Hex');
}
